import { Button, Container, Group, Text, Title } from "@mantine/core";
import { Link } from "react-router-dom";

import classes from "./NotFound.module.scss";

function NotFound() {
  return (
    <>
      <Container className={classes.root}>
        <div className={classes.label}>404</div>
        <Title className={classes.title}>Page not found</Title>
        <Text c="dimmed" size="lg" ta="center" className={classes.description}>
          Unfortunately, this is only a 404 page. You may have mistyped the
          address, or the page has been moved to another URL.
        </Text>
        <Group justify="center">
          <Button component={Link} to="/home" variant="subtle" size="md">
            Back to home page
          </Button>
        </Group>
      </Container>
    </>
  );
}

export default NotFound;
